var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tier__features",class:_vm.stateObj},[_c('div',{staticClass:"tier__features_panel"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.features.disclaimer1'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }